/* Publish by EComposer at 2025-08-05 09:21:05*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-008kh3hn2njnx"]=  window.__ectimmers["ecom-008kh3hn2njnx"] || {};
let e=this.$el,i=e.querySelector(".ecom-product-single__review-wrapper");if(i&&i.dataset.reviewPlatform&&!this.isLive)switch(i.dataset.reviewPlatform){case"product-reviews":if(window.SPR)try{window.SPR.$=window.jQuery,window.SPR.initDomEls(),window.SPR.loadProducts()}catch(t){console.info(t.message)}break;case"judgeme":window.jdgm&&typeof window.jdgm.initializeWidgets=="function"&&window.jdgm.initializeWidgets();break;case"product-reviews-addon":window.StampedFn&&window.StampedFn.init();break;case"yotpo-social-reviews":break;case"lai-reviews":typeof SMARTIFYAPPS!="undefined"&&window.SMARTIFYAPPS.rv.installed&&window.SMARTIFYAPPS.rv.scmReviewsRate.actionCreateReviews();break}

                    });
                    
                        document.querySelectorAll('.ecom-008kh3hn2njnx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-008kh3hn2njnx', settings: {},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}